import 'antd/lib/tooltip/style';
import 'antd/lib/icon/style';

import '../VtxModalList.less';